import {
	addClass,
	eventHandler,
	find,
	findAll,
	listener,
	removeClass
} from "../../../../../modules/vegas/js/util";

listener('click', [
	'[data-cart="qty"] [data-qty="plus"]',
	'[data-cart="qty"] [data-qty="minus"]',
	'[data-cart="qty"] [data-qty="trash"]',
], function (el, e) {
	e.preventDefault();

	let container = el.closest('[data-cart="qty"]'),
		input = find('input', container),
		qty = find('[data-qty="total"]', container);

	let oldValue = parseInt(input.value),
		valueChanged = false,
		min = parseInt(input.getAttribute('min')),
		max = parseInt(input.getAttribute('max')),
		step = parseInt(input.getAttribute('step')) || 1,
		btn = el.dataset.qty,
		unRemove = Boolean(container.dataset.unremove || false);

	if (btn === 'trash') return true;

	let price = container.dataset.price,
		result = inputQtyResult(oldValue, btn, step),
		priceTotal = result * price;

	if (result < min) {
		result = min;
		let text = container.dataset.minText.replace(':cnt', '' + min);
		alert(text);
	}

	if (result > max) {
		result = max;
		let text = container.dataset.maxText.replace(':cnt', '' + max);
		alert(text);
	}

	valueChanged = result !== oldValue;

	input.value = result;
	if (qty) {
		qty.innerText = result;
	}

	input.classList.toggle('is-max', max === result);
	input.classList.toggle('is-min', min === result);

	if (result <= step || result === min) {
		if (!unRemove) {
			findAll('button', container)[0]?.setAttribute('data-qty', 'trash');
		}
	} else {
		findAll('button', container)[0]?.setAttribute('data-qty', 'minus');
	}

	if (valueChanged) {
		eventHandler.on(container, 'change-counter', {
			cnt: result,
			price_total: priceTotal
		})
	}
});

function inputQtyResult(val, sign, step = 1) {
	let result = val;

	if (sign === 'plus') result = val + step;
	if (sign === 'minus') result = val - step;

	result = parseInt(result);

	return result;
}
